import { useContent } from '../hooks/useContent';
import './FAQ.css';

const FaqItem = ({ item }) => (
    <details className="faq-item">
        <summary>
            <div className="faq-q">{item.q}</div>
            <div className="funding-toggle" aria-hidden="true">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M12 5v14M5 12h14"/></svg>
            </div>
        </summary>
        <div className="faq-a">{item.a}</div>
    </details>
);

const MaterialItem = ({ item, previewLabel, downloadLabel }) => (
    <div className="material">
        <div className="file-ico">{item.type}</div>
        <div>
            <b>{item.title}</b>
            <small>{item.meta}</small>
        </div>
        <div className="actions">
            <button className="icon-btn" type="button" aria-label={previewLabel} data-preview-title={item.previewTitle} data-preview-url={item.previewUrl}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.3"><path d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z"/></svg>
            </button>
            <a className="icon-btn" href="#" download aria-label={downloadLabel}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.3"><path d="M12 3v12"/><path d="M7 10l5 5 5-5"/><path d="M5 21h14"/></svg>
            </a>
        </div>
    </div>
);

const Faq = () => {
  const { FAQ, ui } = useContent();
  const f = ui.faq;
  const faqData = [...FAQ, ...f.extraFaq];
  const materialsData = f.materials.map((m, i) => ({
    type: 'PDF',
    ...m,
    previewTitle: m.title,
    previewUrl: 'about:blank',
  }));

  return (
    <div className="services-bg" id="faq">
      <div className="section">
        <div className="section-label">FAQ</div>
        <h2 className="section-title">{f.title}<br/><em>{f.titleEm}</em></h2>
        <p className="section-subtitle" style={{maxWidth: '760px'}}>{f.subtitle}</p>

        <div className="faq-grid">
          <div className="faq-list" aria-label={f.faqListAria}>
            {faqData.map(item => <FaqItem item={item} key={item.q} />)}
          </div>

          <aside className="materials" aria-label={f.materialsAria}>
            <h3 className="materials-title">{f.materialsTitle}</h3>
            {materialsData.map(item => (
              <MaterialItem item={item} key={item.title} previewLabel={f.preview} downloadLabel={f.download} />
            ))}
          </aside>
        </div>
      </div>
    </div>
  );
};

export default Faq;
